import { render, staticRenderFns } from "./AddDoc.vue?vue&type=template&id=f1d3c732&"
import script from "./AddDoc.vue?vue&type=script&lang=js&"
export * from "./AddDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports